export default "__VITE_ASSET__99f56df0__"